// State machine cho Đề tài Cơ sở (Institutional / Internal Research).
// Đồng bộ với backend: cmcu-crt-be-v2/constant/internal_research_status.go.
// Refactor 2026-05-15 thay 30+ status ad-hoc cũ bằng 30 status action-based.

// --- ĐĂNG KÝ ---
export const INT_STATUS_REGISTRATION_DRAFT     = "registration_draft";
export const INT_STATUS_REGISTRATION_SUBMITTED = "registration_submitted";
export const INT_STATUS_MOD_ADJUST_REQUEST     = "mod_adjust_request";
export const INT_STATUS_MOD_REJECTED           = "mod_rejected";
export const INT_STATUS_MOD_ACCEPTED           = "mod_accepted";
export const INT_STATUS_ADMIN_ADJUST_REQUEST   = "admin_adjust_request";
export const INT_STATUS_ADMIN_REJECTED         = "admin_rejected";
export const INT_STATUS_ADMIN_ACCEPTED         = "admin_accepted";

// --- HỘI ĐỒNG #1 (Tuyển chọn) ---
export const INT_STATUS_SELECTION_COUNCIL_PENDING        = "selection_council_pending";
export const INT_STATUS_SELECTION_COUNCIL_ADJUST_REQUEST = "selection_council_adjust_request";
export const INT_STATUS_SELECTION_COUNCIL_REJECTED       = "selection_council_rejected";
export const INT_STATUS_SELECTION_COUNCIL_ACCEPTED       = "selection_council_accepted";

// --- THỰC HIỆN ---
export const INT_STATUS_CONDUCTED        = "conducted";
export const INT_STATUS_CONDUCTED_PHASE2 = "conducted_phase2";

// --- BCTĐ (chỉ 2y) ---
export const INT_STATUS_MIDTERM_REPORT_SUBMITTED = "midterm_report_submitted";

// --- HỘI ĐỒNG #2 (Đánh giá tiến độ) ---
export const INT_STATUS_MIDTERM_COUNCIL_PENDING        = "midterm_council_pending";
export const INT_STATUS_MIDTERM_COUNCIL_ADJUST_REQUEST = "midterm_council_adjust_request";
export const INT_STATUS_MIDTERM_COUNCIL_REJECTED       = "midterm_council_rejected";
export const INT_STATUS_MIDTERM_COUNCIL_ACCEPTED       = "midterm_council_accepted";

// --- TỔNG KẾT + HỘI ĐỒNG #3 ---
export const INT_STATUS_FINAL_REPORT_SUBMITTED       = "final_report_submitted";
export const INT_STATUS_FINAL_COUNCIL_PENDING        = "final_council_pending";
export const INT_STATUS_FINAL_COUNCIL_ADJUST_REQUEST = "final_council_adjust_request";
export const INT_STATUS_FINAL_COUNCIL_REJECTED       = "final_council_rejected";
export const INT_STATUS_FINAL_COUNCIL_ACCEPTED       = "final_council_accepted";

// --- XIN DỪNG ---
export const INT_STATUS_STOP_REQUESTED = "stop_requested";
export const INT_STATUS_STOP_ACCEPTED  = "stop_accepted";
export const INT_STATUS_STOP_REJECTED  = "stop_rejected";

// --- GIA HẠN (chỉ 1y) ---
export const INT_STATUS_EXTENSION_REQUESTED      = "extension_requested";
export const INT_STATUS_EXTENSION_ADJUST_REQUEST = "extension_adjust_request";
export const INT_STATUS_EXTENSION_ACCEPTED       = "extension_accepted";
export const INT_STATUS_EXTENSION_REJECTED       = "extension_rejected";

// Label hiển thị cho user.
export const INTERNAL_RESEARCH_STATUS_LABEL = {
  [INT_STATUS_REGISTRATION_DRAFT]:     "Nháp đăng ký",
  [INT_STATUS_REGISTRATION_SUBMITTED]: "Chờ trưởng đơn vị duyệt",
  [INT_STATUS_MOD_ADJUST_REQUEST]:     "Trưởng đơn vị yêu cầu sửa",
  [INT_STATUS_MOD_REJECTED]:           "Trưởng đơn vị loại",
  [INT_STATUS_MOD_ACCEPTED]:           "Trưởng đơn vị đạt — chờ Phòng QLKH",
  [INT_STATUS_ADMIN_ADJUST_REQUEST]:   "Phòng QLKH yêu cầu sửa",
  [INT_STATUS_ADMIN_REJECTED]:         "Phòng QLKH loại",
  [INT_STATUS_ADMIN_ACCEPTED]:         "Phòng QLKH đạt — chờ Hội đồng tuyển chọn",

  [INT_STATUS_SELECTION_COUNCIL_PENDING]:        "Chờ Hội đồng tuyển chọn",
  [INT_STATUS_SELECTION_COUNCIL_ADJUST_REQUEST]: "HĐ tuyển chọn yêu cầu sửa",
  [INT_STATUS_SELECTION_COUNCIL_REJECTED]:       "HĐ tuyển chọn loại",
  [INT_STATUS_SELECTION_COUNCIL_ACCEPTED]:       "Đã qua HĐ tuyển chọn",

  [INT_STATUS_CONDUCTED]:        "Đang thực hiện",
  [INT_STATUS_CONDUCTED_PHASE2]: "Đang thực hiện (giai đoạn 2)",

  [INT_STATUS_MIDTERM_REPORT_SUBMITTED]: "Đã nộp BCTĐ — chờ HĐ tiến độ",

  [INT_STATUS_MIDTERM_COUNCIL_PENDING]:        "Chờ Hội đồng tiến độ",
  [INT_STATUS_MIDTERM_COUNCIL_ADJUST_REQUEST]: "HĐ tiến độ yêu cầu sửa",
  [INT_STATUS_MIDTERM_COUNCIL_REJECTED]:       "HĐ tiến độ loại",
  [INT_STATUS_MIDTERM_COUNCIL_ACCEPTED]:       "Đã qua HĐ tiến độ",

  [INT_STATUS_FINAL_REPORT_SUBMITTED]:       "Đã nộp tổng kết — chờ HĐ nghiệm thu",
  [INT_STATUS_FINAL_COUNCIL_PENDING]:        "Chờ Hội đồng nghiệm thu",
  [INT_STATUS_FINAL_COUNCIL_ADJUST_REQUEST]: "HĐ nghiệm thu yêu cầu sửa",
  [INT_STATUS_FINAL_COUNCIL_REJECTED]:       "HĐ nghiệm thu loại",
  [INT_STATUS_FINAL_COUNCIL_ACCEPTED]:       "Nghiệm thu đạt",

  [INT_STATUS_STOP_REQUESTED]: "Xin dừng — chờ duyệt",
  [INT_STATUS_STOP_ACCEPTED]:  "Đã dừng đề tài",
  [INT_STATUS_STOP_REJECTED]:  "Từ chối dừng",

  [INT_STATUS_EXTENSION_REQUESTED]:      "Xin gia hạn — chờ duyệt",
  [INT_STATUS_EXTENSION_ADJUST_REQUEST]: "Yêu cầu sửa đơn gia hạn",
  [INT_STATUS_EXTENSION_ACCEPTED]:       "Đã gia hạn",
  [INT_STATUS_EXTENSION_REJECTED]:       "Từ chối gia hạn",
};

// Hành động review (dùng chung với đề tài SV).
export const INT_REVIEW_ACTION_ACCEPT         = "accept";
export const INT_REVIEW_ACTION_REJECT         = "reject";
export const INT_REVIEW_ACTION_ADJUST_REQUEST = "adjust_request";

// Loại hội đồng (3 cấp).
export const INT_COUNCIL_TYPE_SELECTION = "selection"; // HĐ #1 tuyển chọn
export const INT_COUNCIL_TYPE_MIDTERM   = "midterm";   // HĐ #2 đánh giá tiến độ
export const INT_COUNCIL_TYPE_FINAL     = "final";     // HĐ #3 nghiệm thu

// Duration (đơn vị: tháng).
export const INT_DURATION_ONE_YEAR  = 12;
export const INT_DURATION_TWO_YEAR  = 24;
export const INT_DURATION_DEFAULT   = 12;
export const INT_EXTENSION_MONTHS   = 6; // gia hạn 1 lần 6 tháng (chỉ 1y)

export const INT_DURATION_OPTIONS = [
  { value: INT_DURATION_ONE_YEAR, label: "12 tháng (1 năm)" },
  { value: INT_DURATION_TWO_YEAR, label: "24 tháng (2 năm)" },
];

// Status đề tài đang "thực hiện" (cho phép xin dừng / xin gia hạn).
export const INT_STATUS_ACTIVE = [
  INT_STATUS_CONDUCTED,
  INT_STATUS_CONDUCTED_PHASE2,
  INT_STATUS_MIDTERM_REPORT_SUBMITTED,
  INT_STATUS_MIDTERM_COUNCIL_PENDING,
  INT_STATUS_MIDTERM_COUNCIL_ADJUST_REQUEST,
  INT_STATUS_FINAL_REPORT_SUBMITTED,
  INT_STATUS_FINAL_COUNCIL_PENDING,
  INT_STATUS_FINAL_COUNCIL_ADJUST_REQUEST,
];

// Status END (đề tài đã đóng — không cho action mới).
export const INT_STATUS_END = [
  INT_STATUS_MOD_REJECTED,
  INT_STATUS_ADMIN_REJECTED,
  INT_STATUS_SELECTION_COUNCIL_REJECTED,
  INT_STATUS_MIDTERM_COUNCIL_REJECTED,
  INT_STATUS_FINAL_COUNCIL_REJECTED,
  INT_STATUS_FINAL_COUNCIL_ACCEPTED,
  INT_STATUS_STOP_ACCEPTED,
];

// Status assignment hội đồng (3 HĐ đều dùng schema này).
export const INT_COUNCIL_ASSIGNMENT_STATUS_PENDING        = "pending";
export const INT_COUNCIL_ASSIGNMENT_STATUS_ACCEPTED       = "accepted";
export const INT_COUNCIL_ASSIGNMENT_STATUS_ADJUST_REQUEST = "adjust_request";
export const INT_COUNCIL_ASSIGNMENT_STATUS_REJECTED       = "rejected";

export const INT_COUNCIL_ASSIGNMENT_STATUS_LABEL = {
  [INT_COUNCIL_ASSIGNMENT_STATUS_PENDING]:        "Chờ kết quả",
  [INT_COUNCIL_ASSIGNMENT_STATUS_ACCEPTED]:       "Đạt",
  [INT_COUNCIL_ASSIGNMENT_STATUS_ADJUST_REQUEST]: "Yêu cầu chỉnh sửa",
  [INT_COUNCIL_ASSIGNMENT_STATUS_REJECTED]:       "Loại",
};
